import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { withEnvironment } from '../extensions/with-environment';
import {
  IMessage,
  withRootStore,
} from "../../models";
import { ITerms, Terms } from '../terms/Terms';
import { TGeneralApiResponse, TermsApi } from 'src/services';

/**
 * # TermsStore
 *
 * TermsStore을 설명하세요.
 */
export const TermsStore = types
  .model('TermsStore')
  // --------------------------------------------------------------------------
  .props({
    termsList: types.optional(types.array(Terms), []),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  .views((self) => ({}))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    setTermsList: (termsList: ITerms[]) => {
      self.termsList.replace(termsList);
    },
  }))
  // --------------------------------------------------------------------------
  // REQUESTs - 서비스 요청 및 기타 인터페이스 요청 
  .actions((self) => ({
    /** 약관 조회 */
    getTermsList: async (termsType: string, cdssType: string) => {
      self.setTermsList([] as ITerms[]);

      try {
        const termsApi: TermsApi = new TermsApi(self.environment.api);
        const result: TGeneralApiResponse = await termsApi.getTermsList(termsType, cdssType);

        if (self.rootStore.responseStore.getResponseResult(result)) {
          if (self.rootStore.responseStore.responseInfo.resultCode == 'S') {
            const termsList = JSON.parse(JSON.stringify(result)).responseInfo.data;
            self.setTermsList(termsList);
          } else {
            if (self.rootStore.responseStore.responseInfo.message) {
              self.rootStore.messageStore.setMessage({
                content: self.rootStore.responseStore.responseInfo.message,
                isError: true,
              } as IMessage);
            }
          }
        }
      } catch (e) {
        self.rootStore.responseStore.errorProcessing(e);
      }
    },
  }));

// --------------------------------------------------------------------------
type TTermsStore = Instance<typeof TermsStore>;
type TTermsStoreSnapshot = SnapshotOut<typeof TermsStore>;

export interface ITermsStore extends TTermsStore { }
export type TTermsStoreKeys = keyof TTermsStoreSnapshot & string;
export interface ITermsStoreSnapshot extends TTermsStoreSnapshot { }
export const createTermsStore = () => types.optional(TermsStore, {} as TTermsStore);